import { jsx as t, jsxs as S } from "react/jsx-runtime";
import { ReloadIcon as A, CloseIcon as E, ChevronDownIcon as M } from "../../../icons/index.es.js";
import { useState as R, useCallback as j } from "react";
import { IconButton as H } from "../../../atoms/Button/Button.es.js";
import { MagicAniamtedFilledIcon as O } from "../../../atoms/MagicAniamtedFilledIcon/MagicAniamtedFilledIcon.es.js";
import { SmartAnimation as Y } from "../../../atoms/SmartAnimation/SmartAnimation.es.js";
import { Tooltip as $ } from "../../../atoms/Tooltip/Tooltip.es.js";
import { chakra as q, Button as G, Text as J } from "@chakra-ui/react";
import { useDropdownContext as K } from "../../Dropdown/Dropdown.context.es.js";
import "../../Dropdown/components/DropdownItem.es.js";
import "../../Dropdown/Dropdown.container.es.js";
import { SELECT_SORT_LABEL as N } from "../Select.constants.es.js";
import { d as Q, c as U } from "../../../SelectOption-a05022b4.js";
const co = ({
  ariaLabel: v,
  isDisabled: C,
  isFullWidth: m,
  isSmartData: i = !1,
  isLoading: r,
  onClear: n,
  isError: d,
  onRetry: u,
  placeholder: f,
  prefix: s,
  testId: I,
  trackId: g,
  ...e
}) => {
  const { direction: p, selected: o, handleChange: x } = Q(), a = U(), y = !!(!(o != null && o.label) && f), [b, l] = R(!1), {
    buttonRef: B,
    getItemProps: L,
    getReferenceProps: P,
    hasFocusInside: _,
    isOpen: k,
    parent: F,
    setHasFocusInside: w
  } = K(), c = i && r, z = {
    ...a.button,
    ...s ? a.buttonPrefix : {},
    ...y ? a.placeholder : {},
    ...c ? { marginY: 0 } : void 0
  }, D = j(() => d ? /* @__PURE__ */ t(A, { boxSize: 4, marginLeft: "auto", color: "primary.300", onClick: u }) : o && b ? /* @__PURE__ */ t(q.div, { __css: a.clearButtonContainer, children: /* @__PURE__ */ t(
    $,
    {
      label: "Clear info added by Smart Profiles",
      "aria-label": "Clear info added by Smart Profiles",
      placement: "top-end",
      shouldWrapChildren: !0,
      children: /* @__PURE__ */ t(
        H,
        {
          as: "span",
          "aria-label": "Clear",
          icon: /* @__PURE__ */ t(E, { color: "primary.300" }),
          onClick: () => {
            n == null || n(), x(""), l(!1);
          },
          onMouseLeave: () => l(!1),
          size: "sm",
          variant: "transparent",
          sx: a.iconButton
        }
      )
    }
  ) }) : i ? /* @__PURE__ */ t(
    O,
    {
      animated: r,
      marginLeft: "auto",
      onMouseEnter: () => {
        o && l(!0);
      }
    }
  ) : /* @__PURE__ */ t(M, { boxSize: 4, marginLeft: "auto" }), [i, r, d, u, b, n, o]);
  return /* @__PURE__ */ t(Y, { isLoading: c, size: m ? "fullwidth" : void 0, children: /* @__PURE__ */ S(
    G,
    {
      __css: z,
      "data-animation": c ? "true" : "false",
      "aria-label": v,
      "data-focus-inside": _ ? "" : void 0,
      "data-open": k ? "" : void 0,
      "data-testid": I,
      isDisabled: C,
      ref: B,
      "track-id": g,
      variant: "unstyled",
      width: m ? "100%" : void 0,
      ...e,
      ...P(
        L({
          onFocus(T) {
            var h;
            (h = e.onFocus) == null || h.call(e, T), w(!1), F.setHasFocusInside(!0);
          }
        })
      ),
      children: [
        s && /* @__PURE__ */ S(J, { as: "span", children: [
          s,
          ":"
        ] }),
        o == null ? void 0 : o.icon,
        (o == null ? void 0 : o.label) ?? f,
        " ",
        o != null && o.isSorting && p ? `(${N[p]})` : void 0,
        /* @__PURE__ */ t(D, {})
      ]
    }
  ) });
};
export {
  co as SelectButton
};
//# sourceMappingURL=SelectButton.es.js.map
